<template>
    <div class="container mx-auto mb-60px">
        <div class="flex flex-row-reverse mx-4 xl:-mx-4">
            <div class="w-full mx-4 overflow-hidden">
                <div class="flex flex-wrap flex-row-reverse col2-list-dashed -m-4">
                    <SectionSlotSmComponent
                        v-for="article,articleIndex in data"
                        :key="articleIndex"
                        :article="article"
                        :slug="slug"
                        classes="w-1/2 md:w-1/4" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SectionSlotSmComponent from './Slots/SectionSlotSmComponent.vue'

export default{
    props: ['data', 'slug'],
    components: {
        SectionSlotSmComponent,
    }
}
</script>